module.exports = __webpack_public_path__ + "img/logo.46178e14.png";